import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { tapResponse } from '@ngrx/operators';
import { Observable, switchMap } from 'rxjs';
import { ELoadStatus } from '../../../state/state.interface';
import { IBaseResponse } from '../../../utilities/http-utilities.service';
import { ESnackbar, SnackbarService } from '../../../utilities/snackbar.service';

export interface IKanbanViewComponentState {
  dataLoading: ELoadStatus;
}

export interface IRankTransition {
  previousItemId: number | null;
  nextItemId: number | null;
  itemId: number;
  targetWorkflowStepId: number;
}

export interface IRankTransitionRequest {
  assignment: IRankTransition;
  /** Pre-translated message shown as a success toast once the API confirms the change. */
  successMessage?: string;
}

@Injectable()
export class IKanbanViewStore extends ComponentStore<IKanbanViewComponentState> {
  public readonly dataStatus$ = this.select((state: IKanbanViewComponentState) => state.dataLoading);

  readonly changeRange = this.effect((trigger$: Observable<IRankTransitionRequest>) =>
    trigger$.pipe(
      switchMap(({ assignment, successMessage }: IRankTransitionRequest) => {
        this.patchState({ dataLoading: ELoadStatus.loading });

        return this.updateItem(assignment).pipe(
          tapResponse(
            () => {
              this.patchState({ dataLoading: ELoadStatus.success });

              if (successMessage) {
                this.snackbar.open(successMessage, ESnackbar.success);
              }
            },
            () => {
              this.patchState({ dataLoading: ELoadStatus.failure });
            },
          ),
        );
      }),
    ),
  );

  constructor(
    private readonly http: HttpClient,
    private readonly snackbar: SnackbarService,
  ) {
    super({
      dataLoading: ELoadStatus.initial,
    });
  }

  private updateItem(assignment: IRankTransition): Observable<IBaseResponse<void>> {
    return this.http.patch<IBaseResponse<void>>('items/change-rank', assignment);
  }
}
